import { useStaticQuery } from "gatsby";
export var useActiveBanner = function useActiveBanner() {
    var _useStaticQuery = useStaticQuery("3939919066"), allDatoCmsBanner = _useStaticQuery.allDatoCmsBanner;
    return allDatoCmsBanner.nodes && allDatoCmsBanner.nodes.length > 0 ? allDatoCmsBanner.nodes[0] : undefined;
};
